<template>
	<g clip-path="url(#clip0_414_8034)">
		<path
			d="M9.08548 2.91388L13.0861 6.91451L4.39891 15.6017L0.832039 15.9954C0.354539 16.0483 -0.0488989 15.6445 0.00422611 15.167L0.401101 11.5976L9.08548 2.91388ZM15.5605 2.31826L13.682 0.439819C13.0961 -0.146118 12.1458 -0.146118 11.5599 0.439819L9.79266 2.20701L13.7933 6.20763L15.5605 4.44044C16.1464 3.85419 16.1464 2.90419 15.5605 2.31826Z"
			fill="#E2E2E2"
		/>
	</g>
	<defs>
		<clipPath id="clip0_414_8034">
			<rect width="16" height="16" fill="white" />
		</clipPath>
	</defs>
</template>
